import React from 'react';
import { IconButton, Tooltip } from "@mui/material";
import { TimesIcon } from "src/icons/quote/TimesIcon";

export const CancelButton = (
    {
      title,
      cancelCustomRow,
      modifyRow,
      setModifyRow,
      modifyMode,
      setModifyMode,
    }: {
      title: string;
      cancelCustomRow: any;
      modifyRow: any;
      setModifyRow: any;
      modifyMode: any;
      setModifyMode: any;
    }
) => {

  return (
      <Tooltip title={title}>
        <IconButton
            onClick={() => {
                cancelCustomRow();
                if (modifyRow) {
                  setModifyRow(false);
                }
                if (modifyMode) {
                  setModifyMode(false);
                }
              }
            }
        >
          <TimesIcon/>
        </IconButton>
      </Tooltip>
  );
};
